import axios from 'axios';

import { getGuestAccessToken } from '../utils';

const hermesServiceURL = process.env.VUE_APP_HERMES_API_URL;

export let promise = undefined;

export const checkEditorAvailability = () => {
    if (promise) return promise;

    const token = getGuestAccessToken();

    promise = axios
        .get(`${hermesServiceURL}/api/v2/orders/is_editor_available/`, {
            headers: {
                Authorization: `Guest ${token}`,
            },
        })
        .then((response) => {
            promise = undefined;

            return response.data;
        })
        .catch((error) => {
            promise = undefined;

            throw error;
        });

    return promise;
};
